export type TicketType = 'bug' | 'melhoria';
export type TicketPriority = 'baixa' | 'media' | 'alta' | 'critica';
export type TicketStatus = 'aberto' | 'em_analise' | 'em_desenvolvimento' | 'resolvido' | 'fechado';
export type TicketArea = 'frontend' | 'backend' | 'qa' | 'design';

export interface TicketUser {
  _id: string;
  name: string;
  email: string;
}

export interface TicketServiceOrder {
  _id: string;
  name: string;
  code: string;
}

export interface TicketComment {
  _id: string;
  ticketId: string;
  autorId: TicketUser;
  conteudo: string;
  createdAt: string;
  updatedAt: string;
}

export interface Ticket {
  _id: string;
  titulo: string;
  descricao: string;
  tipo: TicketType;
  prioridade: TicketPriority;
  status: TicketStatus;
  area: TicketArea;
  estimatedHours?: number;
  projectId: string;
  serviceOrderId?: TicketServiceOrder | string;
  autorId: TicketUser;
  responsavelId?: TicketUser;
  taskId?: string;
  tipoLabel?: string;
  prioridadeLabel?: string;
  statusLabel?: string;
  areaLabel?: string;
  comments?: TicketComment[];
  createdAt: string;
  updatedAt: string;
}

export interface CreateTicketRequest {
  titulo: string;
  descricao: string;
  tipo: TicketType;
  prioridade?: TicketPriority;
  area: TicketArea;
  estimatedHours?: number;
  serviceOrderId?: string;
  responsavelId?: string;
}

export interface UpdateTicketRequest {
  titulo?: string;
  descricao?: string;
  tipo?: TicketType;
  prioridade?: TicketPriority;
  status?: TicketStatus;
  area?: TicketArea;
  estimatedHours?: number;
  serviceOrderId?: string | null;
  responsavelId?: string | null;
}

export interface TicketFilters {
  status?: TicketStatus;
  tipo?: TicketType;
  prioridade?: TicketPriority;
  area?: TicketArea;
  serviceOrderId?: string;
}

// Labels for display
export const ticketTypeLabels: Record<TicketType, string> = {
  bug: '🐛 Bug',
  melhoria: '💡 Melhoria'
};

export const ticketPriorityLabels: Record<TicketPriority, string> = {
  baixa: 'Baixa',
  media: 'Média',
  alta: 'Alta',
  critica: 'Crítica'
};

export const ticketStatusLabels: Record<TicketStatus, string> = {
  aberto: 'Aberto',
  em_analise: 'Em Análise',
  em_desenvolvimento: 'Em Desenvolvimento',
  resolvido: 'Resolvido',
  fechado: 'Fechado'
};

export const ticketAreaLabels: Record<TicketArea, string> = {
  frontend: 'Frontend',
  backend: 'Backend',
  qa: 'QA',
  design: 'Design'
};

export const ticketPriorityColors: Record<TicketPriority, string> = {
  baixa: '#22c55e',
  media: '#3b82f6',
  alta: '#f97316',
  critica: '#ef4444'
};

export const ticketStatusColors: Record<TicketStatus, string> = {
  aberto: '#6b7280',
  em_analise: '#8b5cf6',
  em_desenvolvimento: '#3b82f6',
  resolvido: '#22c55e',
  fechado: '#9ca3af'
};
